// PowerShell commands for Microsoft Active Directory data export

export const AD_GROUP_POLICY_COMMAND = "gpresult /H C:\\Breeze-GPO.html";

export const AD_INVENTORY_COMMAND =
  "Get-ADObject -Filter * -Properties * | ForEach-Object { $flat = @{}; foreach ($prop in $_.PSObject.Properties) { $name = $prop.Name; if ($name -ne 'PropertyNames') { $val = $prop.Value; if ($val -is [System.Collections.IEnumerable] -and -not ($val -is [string])) { $flat[$name] = $val -join \"`r`n\" } else { $flat[$name] = $val } } }; [PSCustomObject]$flat | Out-String } | Out-File C:\\Breeze_AD_Inventory.txt -Width 4096";

export const AD_USERS_COMMAND =
  "Get-ADUser -Filter * -Properties * | ForEach-Object { $flat = @{}; $_.PSObject.Properties | ForEach-Object { if ($_.Value -is [System.Collections.IEnumerable] -and -not ($_.Value -is [string])) { $flat[$_.Name] = ($_.Value -join '; ') } else { $flat[$_.Name] = $_.Value } }; [PSCustomObject]$flat } | Export-Csv C:\\Breeze_AD_Users.csv -NoTypeInformation";

// Microsoft Active Directory file type definitions
export const MicrosoftADFiles = Object.freeze({
  DOMAIN_CONTROLLER: {
    key: "domain_controller_config",
    fileTypes: ["html", "htm"],
    fileFormat: "HTML",
  },
  SERVER: {
    key: "server_config",
    fileTypes: ["html", "htm"],
    fileFormat: "HTML",
  },
  ENDPOINT: {
    key: "endpoint_config",
    fileTypes: ["html", "htm"],
    fileFormat: "HTML",
  },
  INVENTORY: {
    key: "inventory_config",
    fileTypes: ["txt"],
    fileFormat: "TXT",
  },
  USERS: {
    key: "users_config",
    fileTypes: ["csv"],
    fileFormat: "CSV",
  },
});
